import script from "./PersonalInformationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalInformationPage.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalInformationPage.vue?vue&type=style&index=0&id=3fb6d1ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb6d1ee"]])

export default __exports__